class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;
    this._contentLeaveTimer = null;
    this._clickOutsideHandler = null;
    this._lastMouseX = 0;
    this._lastMouseY = 0;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    document.addEventListener('mousemove', (e) => {
      this._lastMouseX = e.clientX;
      this._lastMouseY = e.clientY;
    });

    if (this.content) {
      this.content.addEventListener('mouseenter', this.onContentMouseEnter.bind(this));
      this.content.addEventListener('mouseleave', this.onContentMouseLeave.bind(this));
    }
  }

  onMouseEnter() {
    if (window.innerWidth < 1100) return;
    clearTimeout(this._closeTimer);
    clearTimeout(this._contentLeaveTimer);
    if (!this.mainDetailsToggle.open) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (window.innerWidth < 1100) return;
    this._closeTimer = setTimeout(() => this.close(), 120);
  }

  onContentMouseEnter() {
    if (window.innerWidth < 1100) return;
    clearTimeout(this._contentLeaveTimer);
  }

  onContentMouseLeave() {
    if (window.innerWidth < 1100) return;
    this._contentLeaveTimer = setTimeout(() => {
      const el = document.elementFromPoint(this._lastMouseX, this._lastMouseY);
      if (el && this.contains(el)) return;
      this.close();
    }, 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    const anyOpen = !!this.header.querySelector('details[open]');
    document.body.classList.toggle('dropdown-open', anyOpen);

    if (this.mainDetailsToggle.open) {
      // Register a click-outside listener each time the menu opens
      this._clickOutsideHandler = (e) => {
        if (!this.contains(e.target) || e.target === this.mainDetailsToggle) {
          this.close();
        }
      };
      // Defer by one frame so the opening click/hover doesn't immediately trigger it
      requestAnimationFrame(() => {
        document.addEventListener('click', this._clickOutsideHandler);
      });
    } else {
      // Clean up when the menu closes
      if (this._clickOutsideHandler) {
        document.removeEventListener('click', this._clickOutsideHandler);
        this._clickOutsideHandler = null;
      }
    }
  }
}

customElements.define('header-menu', HeaderMenu);
